/**
 * useTheme
 *
 * Thin accessor hook over ThemeContext.
 */
import { useContext } from 'react';
import { ThemeContext } from '../context/themeContextInstance.js';

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return ctx;
};
